export var createReadVariableSizeInteger = function (readVariableSizeIntegerLength) {
    return function (dataView, offset) {
        var length = readVariableSizeIntegerLength(dataView, offset);
        if (length === null) {
            return length;
        }
        var firstDataByteOffset = offset + Math.floor((length - 1) / 8);
        if (firstDataByteOffset + length > dataView.byteLength) {
            return null;
        }
        var firstDataByte = dataView.getUint8(firstDataByteOffset);
        var value = firstDataByte & ((1 << (8 - (length % 8))) - 1); // tslint:disable-line:no-bitwise
        for (var i = 1; i < length; i += 1) {
            value = (value << 8) + dataView.getUint8(firstDataByteOffset + i); // tslint:disable-line:no-bitwise
        }
        return { length: length, value: value };
    };
};
//# sourceMappingURL=read-variable-size-integer.js.map
